import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";

/**
 * Atualiza uma Organization pelo `id` atual do recurso.
 *
 * Por que existe:
 * - `PutOrganization.tsx` monta a URL usando `oids.cnpj-${cnpj}`.
 * - No fluxo de migração CPF→CNPJ, o recurso atual pode ter `id` diferente.
 * - Aqui garantimos consistência: atualiza o MESMO recurso, preservando dados atuais.
 */
export async function PutOrganizationById(params: {
  organizationId: string;
  fhirOrganization: fhir5.Organization;
}) {
  const { organizationId, fhirOrganization } = params;
  if (!organizationId) throw new Error("PutOrganizationById: id inválido");

  const url = `${endpoints.ADMFHIR}/Organization/${organizationId}`;
  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .put(url, fhirOrganization, { headers, timeout: 20000 })
    .then((response) => {
      if (
        response.status !== HTTPResponseStatus.Success &&
        response.status !== HTTPResponseStatus.Created
      ) {
        throw new Error(`PutOrganizationById: ${response.status}`);
      }
      return { data: response.data, status: response.status };
    })
    .catch((error) => {
      console.error("PutOrganizationById ", error);
      throw new Error();
    });

  return response;
}

